module.exports = __webpack_public_path__ + "static/media/customer-dole.a823316b.png";